/**
 * Module-level singletons for the in-flight chat turn — shared between
 * `useChatStream` (which owns the SSE loop and writes the abort
 * controller) and `useSessionLifecycle` (which cancels the in-flight
 * turn on session switch / new chat). Mirrors the singleton pattern
 * already used by `cancelReattach` in `chatReattach.ts`.
 *
 * There is only ever one chat conversation in flight per app instance —
 * the chat store is a singleton, so the abort + stop refs that govern
 * the active turn are too. Lifting these out of `useChat`'s `useRef`
 * scope lets the hook split cleanly without threading the refs through
 * every callback signature.
 *
 * Both fields use the `{ current: T }` shape so they're shape-compatible
 * with `recoverFromStreamDrop`'s `stopSignal` parameter (a structural
 * subset of `MutableRefObject<boolean>`).
 */
export const chatAbort: { current: AbortController | null } = { current: null };

/** Set by `stopStreaming()` and polled by the recovery loop so a Stop
 *  click during reconnect exits immediately rather than running out the
 *  timeout. Reset at the start of every new turn. */
export const chatStop: { current: boolean } = { current: false };
